import React from "react";
import ProgressBar from "./progressbar";

const Header: React.VFC<{
    currentQuestionNo: number;
    allQuestionCount: number;
    backPreviousQuestion: Function;
    isHideBackButton?: boolean;
    isHideProgressBar?: boolean;
}> = ({
    currentQuestionNo,
    allQuestionCount,
    backPreviousQuestion,
    isHideBackButton,
    isHideProgressBar,
}) => {
    const progress = ((currentQuestionNo - 1) / allQuestionCount) * 100;
    return (
        <>
            <div className="flex justify-between h-12 border-0 border-b-2 border-solid border-gray-light px-4 relative z-20">
                {isHideBackButton ? (
                    <div />
                ) : (
                    <div
                        className="flex justify-center items-center cursor-pointer"
                        onClick={(e) => {
                            backPreviousQuestion();
                        }}
                    >
                        <i className="Icon-Back" />
                    </div>
                )}
                <div className="Icon-Title leading-[46px] md:transform md:scale-[1.2]">
                    <a href="https://sakurawada.jp">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="160"
                            height="10"
                        >
                            <defs>
                                <clipPath id="a">
                                    <path
                                        data-name="長方形 13673"
                                        fill="none"
                                        d="M0 0h136.819v10H0z"
                                    />
                                </clipPath>
                            </defs>
                            <g data-name="グループ 24473">
                                <path
                                    data-name="長方形 13674"
                                    fill="rgba(255,255,255,0)"
                                    d="M0 0h160v10H0z"
                                />
                                <g
                                    data-name="グループ 24470"
                                    transform="translate(12)"
                                    clip-path="url(#a)"
                                    fill="#1a1818"
                                >
                                    <path
                                        data-name="パス 9716"
                                        d="M5.415 4.866A6.86 6.86 0 0 0 4 4.049a.437.437 0 0 1-.089-.032.714.714 0 0 1-.077-.045 7.712 7.712 0 0 1-.964-.5 1.616 1.616 0 0 1-.479-.428.822.822 0 0 1-.14-.466.871.871 0 0 1 .153-.5 1.089 1.089 0 0 1 .421-.358 1.383 1.383 0 0 1 .626-.134 1.636 1.636 0 0 1 .888.236 2.361 2.361 0 0 1 .7.722l1.226-.983A3.353 3.353 0 0 0 5.07.415 3.344 3.344 0 0 0 3.384 0a3.233 3.233 0 0 0-1.5.345A2.669 2.669 0 0 0 .83 1.29a2.418 2.418 0 0 0-.383 1.328 2.371 2.371 0 0 0 .281 1.194 2.678 2.678 0 0 0 .811.862 7.993 7.993 0 0 0 1.386.741q.051.026.109.051l.121.051a4.639 4.639 0 0 1 .907.517 1.518 1.518 0 0 1 .447.511 1.431 1.431 0 0 1 .128.632 1.339 1.339 0 0 1-.153.651 1.079 1.079 0 0 1-.453.441 1.489 1.489 0 0 1-.709.16 1.952 1.952 0 0 1-1.475-.639 2.879 2.879 0 0 1-.517-.8L0 7.842a3.494 3.494 0 0 0 .747 1.136 3.344 3.344 0 0 0 1.143.754A3.924 3.924 0 0 0 3.372 10a3.453 3.453 0 0 0 1.577-.351 2.7 2.7 0 0 0 1.1-1 2.752 2.752 0 0 0 .4-1.488A3.2 3.2 0 0 0 6.2 5.837a2.6 2.6 0 0 0-.785-.971"
                                    />
                                    <path
                                        data-name="パス 9717"
                                        d="m15.376.192-4.309 9.63h1.9l.919-2.158h3.941l.87 2.158h1.941L16.487.192Zm1.838 5.951h-2.686l.592-1.392q.268-.639.524-1.271c.087-.215.17-.432.254-.648.2.524.446 1.159.755 1.919Z"
                                    />
                                    <path
                                        data-name="パス 9718"
                                        d="M33.742.192h-2.248l-3.5 3.9.013-3.9H26.22v9.63h1.788l-.013-4.189.24-.168 3.285 4.357h2.286l-4.193-5.264Z"
                                    />
                                    <path
                                        data-name="パス 9719"
                                        d="M45.057 6.067a3.068 3.068 0 0 1-.243 1.322 1.564 1.564 0 0 1-.677.734 2.125 2.125 0 0 1-1.009.23 2.078 2.078 0 0 1-1.009-.23 1.589 1.589 0 0 1-.664-.728 2.954 2.954 0 0 1-.243-1.29V.192h-1.8v6.117a3.841 3.841 0 0 0 .492 1.992 3.271 3.271 0 0 0 1.328 1.264 4.345 4.345 0 0 0 3.787 0 3.219 3.219 0 0 0 1.328-1.263 3.881 3.881 0 0 0 .485-1.992V.192h-1.775Z"
                                    />
                                    <path
                                        data-name="パス 9720"
                                        d="M58.543 5.358a2.711 2.711 0 0 0 .862-.99 2.778 2.778 0 0 0 .288-1.264 2.761 2.761 0 0 0-.467-1.648 2.689 2.689 0 0 0-1.3-.958 5.735 5.735 0 0 0-1.975-.306h-2.133v9.63h1.776V6.016h.273l2.51 3.806h2.146l-2.881-4a4.192 4.192 0 0 0 .9-.468m-2.949-3.6h.5a2.933 2.933 0 0 1 1.022.153 1.278 1.278 0 0 1 .619.453 1.315 1.315 0 0 1 .211.773 1.37 1.37 0 0 1-.224.8 1.339 1.339 0 0 1-.645.479 2.978 2.978 0 0 1-1.047.16h-.434Z"
                                    />
                                    <path
                                        data-name="パス 9721"
                                        d="m69.898.192-4.3 9.63h1.89l.919-2.158h3.939l.87 2.158h1.942l-4.15-9.63Zm1.838 5.951h-2.69l.6-1.392q.268-.639.524-1.271c.087-.215.17-.431.254-.648.2.524.446 1.159.755 1.919Z"
                                    />
                                    <path
                                        data-name="パス 9722"
                                        d="M92.401 6.501 90.191.192h-.677l-2.273 6.309L84.929.192h-1.9l3.768 9.63h.868l2.172-6.054 2.104 6.054h.881l3.934-9.63h-1.9Z"
                                    />
                                    <path
                                        data-name="パス 9723"
                                        d="m104.189.192-4.3 9.63h1.89l.919-2.158h3.946l.864 2.158h1.942l-4.151-9.63Zm1.838 5.951h-2.686l.592-1.392q.268-.639.524-1.271c.087-.215.17-.431.254-.648.2.524.446 1.159.755 1.919Z"
                                    />
                                    <path
                                        data-name="パス 9724"
                                        d="M120.206.76a6.852 6.852 0 0 0-2.889-.568h-2.286v9.63h2.324a6.766 6.766 0 0 0 2.855-.562 4.314 4.314 0 0 0 1.896-1.638 4.824 4.824 0 0 0 .677-2.612 4.843 4.843 0 0 0-.671-2.593A4.285 4.285 0 0 0 120.206.76m.351 5.983a2.751 2.751 0 0 1-1.245 1.086 4.563 4.563 0 0 1-1.909.37h-.6V1.822h.6a4.576 4.576 0 0 1 1.986.383 2.658 2.658 0 0 1 1.2 1.092 3.4 3.4 0 0 1 .4 1.7 3.293 3.293 0 0 1-.434 1.737"
                                    />
                                    <path
                                        data-name="パス 9725"
                                        d="M134.878 9.822h1.942l-4.152-9.63h-1.111l-4.3 9.63h1.89l.919-2.158h3.937Zm-4.168-3.678.592-1.392q.268-.639.524-1.271c.087-.215.17-.431.254-.648.2.524.446 1.159.755 1.919l.561 1.392Z"
                                    />
                                </g>
                            </g>
                        </svg>
                    </a>
                </div>
                <div
                    className="flex justify-center items-center cursor-pointer"
                    style={isHideBackButton ? { width: 0 } : {}}
                >
                    <i className="Icon-Menu" />
                </div>
            </div>
            {!isHideProgressBar && <ProgressBar progress={progress} />}
        </>
    );
};

export default Header;
